/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PaginationInfo,
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaginatedResponse
 */
export interface PaginatedResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof PaginatedResponse
     */
    paginationInfo: PaginationInfo;
}

export function PaginatedResponseFromJSON(json: any): PaginatedResponse {
    return PaginatedResponseFromJSONTyped(json, false);
}

export function PaginatedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
    };
}

export function PaginatedResponseToJSON(value?: PaginatedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paginationInfo': PaginationInfoToJSON(value.paginationInfo),
    };
}


